import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import { useAppDispatch, useAppState } from "@/store/useApp";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingGenerateReportHint = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();
  const document = useAppState((state) => state.currentDocument);
  const isReferencePanelOpen = useAppState((state) => state.referencePanel.visible);
  const dispatch = useAppDispatch();
  const hasPending = document?.suggestions.some((suggestion) => suggestion.rubricCriteriaId && suggestion.status === "pending");

  if (!hasPending && currentStep?.id as OnboardingSteps === "generate_report") {
    if (isReferencePanelOpen) {
      dispatch({
        type: "SHOW_REFERENCE_PANEL",
        payload: {
          visible: false,
        },
      });
    }

    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.generateReportHint}
          defaultOpen={true}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingGenerateReportHint;